import { useState } from "react";
import "./css/cotizarepuestos.css"
import { Card, Container, Modal, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import "../../global.css"
import Col from "react-bootstrap/Col";
import { Controller, useForm } from "react-hook-form";
import { verificarCedula } from "udv-ec";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { makeStyles, } from "@material-ui/core";
import cuid from "cuid";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import axios from "axios";
import { Server } from "../../constants";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";
import Logo from "../../images/assets/hyundai-logo.webp";
import Image from "react-bootstrap/Image";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing(3),
    },
}));

function InfoDerechoArco() {
    const [option, setOption] = useState('female');
    const classes = useStyles();
    const [showModal, setShowModal] = useState(true);
    const handleCloseModal = () => setShowModal(false);
    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            identificacion: "",
            nombre: "",
            apellido: "",
            celular: "",
            correo: "",
            opcion: "",
            info: ""
        }
    });
    const [showBackdrop, setShowBackdrop] = useState(false);

    const guardarInformacionDerecho = (bodyRequest) => {
        const resultado = axios.post(Server + "/api/proteccionDatos/guardar", bodyRequest);
        return resultado;
    };

    const onSubmit = async (formData) => {
        const dataForm = new FormData();
        let cid = cuid();
        dataForm.append("id", cid);
        dataForm.append('nombre', formData.nombre);
        dataForm.append('apellido', formData.apellido)
        dataForm.append('identificacion', formData.identificacion)
        dataForm.append('celular', formData.celular)
        dataForm.append('email', formData.correo)
        dataForm.append('opcion', formData.opcion)
        dataForm.append('info', formData.info)
        setShowBackdrop(true);
        const respuestaServicio = await guardarInformacionDerecho(dataForm);
        if (respuestaServicio?.status) {
            limpiarFormulario();
            Swal.fire({
                title: "ÉXITO",
                text: "Su cotización fue generada con éxito, pronto un asesor Hyundai te contactará.",
                showCloseButton: true,
                icon: "success",
            });
        } else {
            Swal.fire({
                title: "Información",
                text: "No se pudo generar la cotización, por favor intente en unos minutos.",
                showCloseButton: true,
                icon: "info",
            });
        }
        setShowBackdrop(false);
    }

    const limpiarFormulario = () => {
        setValue('identificacion', "");
        setValue('nombre', "");
        setValue('apellido', "");
        setValue('telefono', "");
        setValue('celular', "");
        setValue('correo', "");
        setValue('selectCiudad', "");
        setValue('selectConcesionario', "");
        setValue('descripcionRepuesto', "");
        setValue('chasis', "");
    }

    const handleChange = (event) => {
        setOption(event.target.value);
    };

    return (
        <div>
            <Container fluid={true} className="banner-legal">
                <Row>
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Body className="text-center">
                            <Image width="150" height="21" src={Logo} alt="Logo" className="modal-image1" />
                            <p className="mt-3"><strong>Ley de proteccion de datos</strong></p>
                            <p>Estimado cliente,</p>
                            <p>
                                El formulario de atención de derechos ARCO+ tiene la finalidad de ser una herramienta para el ejericio de derechos sobre proteción de datos personales, si desea enviar un requerimiento en esta materia, por favor haga click en continuar.
                                Si deseas recibir información comercial sobre nuestros productos y servicios haz click <a href="https://www.hyundai.com.ec/vehiculos">aquí</a>.
                            </p>
                            <p>
                                Agradecemos tu interés en Hyundai Ecuador
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Continuar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Col md={12} className="px-0">
                        <Card>
                            <Card.Img
                                src={BannerDatos}
                                width="1920"
                                height="357"
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-none d-sm-block img1"
                            />
                            <Card.Img
                                src={BannerDatosmobile}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-block d-sm-none"
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-legal w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="legal-banner-titulo">
                                            Ley de protección de datos personales
                                        </h1>
                                        <br />
                                        <h2 className="legal-banner-subtitulo">Hyundai Ecuador.</h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <div>
                <Container>
                    <Row className="centrar-global">
                        <Card className="card-repuestos mb-5 ">
                            <Card.Header style={{ backgroundColor: '#002c5f', color: 'white' }}>
                                <h1 className='titulo-card-repuesto'>Protección de datos</h1>
                            </Card.Header>
                            <form onSubmit={handleSubmit(onSubmit)} id="formCotizador">
                                <Card.Body className="card-height-repuestos">
                                    <p className="h-head-r h14">Hyundai Ecuador pone a tu disposición este formulario de atención de derechos, vía por la cual podremos atender tus necesidades en materia de datos personales. Para proseguir con tu solicitud, es necesario que nos proporciones la siguiente información del titular de datos: </p>
                                    <p className="h-head-r h14">* Por favor complete el siguiente formulario.</p>
                                    <Row>
                                        <Col>
                                            <div className="input-repuestos">
                                                <label htmlFor="identificacion">Número de cédula:</label>
                                                <Controller
                                                    rules={{
                                                        required: 'Identificación requerida',
                                                        validate: (value) =>
                                                            verificarCedula(value) || "Cédula incorrecta"
                                                    }}
                                                    name="identificacion"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) =>
                                                        <InputMask
                                                            mask="9999999999"
                                                            maskChar=" "
                                                            name="identificacion"
                                                            value={value}
                                                            onChange={onChange}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    placeholder="Identificación"
                                                                />
                                                            )}
                                                        </InputMask>}
                                                />
                                                {errors.identificacion ?
                                                    <span className="message-error-repuestos">
                                                        {errors.identificacion.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="nombre">Nombres:</label>
                                                <input
                                                    id="nombre"
                                                    type="text"
                                                    placeholder="Nombres"
                                                    {
                                                    ...register("nombre",
                                                        {
                                                            required: "Nombre requerido",
                                                            maxLength: 100
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.nombre ?
                                                    <span className="message-error-repuestos">
                                                        {errors.nombre.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="apellido">Apellidos:</label>
                                                <input type="text"
                                                    placeholder="Apellidos"
                                                    id="apellido"
                                                    {
                                                    ...register("apellido",
                                                        {
                                                            required: "Apellido requerido",
                                                            maxLength: 100
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.apellido ?
                                                    <span className="message-error-repuestos">
                                                        {errors.apellido.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="celular">Celular:</label>
                                                <Controller
                                                    rules={{ required: 'Número requerido' }}
                                                    name="celular"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) =>
                                                        <InputMask
                                                            id="celular"
                                                            type="text"
                                                            mask="09 9999 9999"
                                                            maskChar=" "
                                                            value={value}
                                                            onChange={onChange}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    placeholder="09 8765 4321"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    }
                                                />
                                                {errors.celular ?
                                                    <span className="message-error-repuestos">
                                                        {errors.celular.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <label htmlFor="correo">Correo electrónico:</label>
                                                <input type="text"
                                                    placeholder="usuario@correo.com"
                                                    id="correo"
                                                    {
                                                    ...register("correo",
                                                        {
                                                            required: "Correo electrónico requerido",
                                                            maxLength: 50,
                                                            pattern: {
                                                                value: /^(([^<>()\]\\.,;:\s@”]+(\.[^<>()\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/,
                                                                message: "Dirrección de correo no válido"
                                                            }
                                                        }
                                                    )
                                                    }
                                                />
                                                {errors.correo ?
                                                    <span className="message-error-repuestos">
                                                        {errors.correo.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <p className="h-head-r h14">Seleccione el derecho que desea ejercer:</p>
                                                <RadioGroup
                                                    {
                                                    ...register("opcion",
                                                        {
                                                            required: "Opción requerida",
                                                            maxLength: 100
                                                        }
                                                    )
                                                    }
                                                    aria-label="gender" id="opcion" name="opcion" value={option} onChange={handleChange}>
                                                    <FormControlLabel value="1. Información" control={<Radio />} label="1. Información" />
                                                    <FormControlLabel value="2. Acceso" control={<Radio />} label="2. Acceso" />
                                                    <FormControlLabel value="3. Rectificación y actualización" control={<Radio />} label="3. Rectificación y actualización" />
                                                    <FormControlLabel value="4. Eliminación" control={<Radio />} label="4. Eliminación" />
                                                    <FormControlLabel value="5. Oposición" control={<Radio />} label="5. Oposición" />
                                                    <FormControlLabel value="6. Portabilidad" control={<Radio />} label="6. Portabilidad" />
                                                    <FormControlLabel value="7. Suspensión del tratamiento" control={<Radio />} label="7. Suspensión del tratamiento" />
                                                    <FormControlLabel value="8. Derecho a no ser objeto de una decisión basada en valoraciones automatizadas" control={<Radio />} label="8. Derecho a no ser objeto de una decisión basada en valoraciones automatizadas" />
                                                    <FormControlLabel value="9. Revocatoria del consentimiento" control={<Radio />} label="9. Revocatoria del consentimiento" />
                                                </RadioGroup>
                                                {errors.opcion ?
                                                    <span className="message-error-repuestos">
                                                        {errors.opcion.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                            <div className="input-repuestos">
                                                <p className="h-head-r h14">Cuéntanos de manera clara y precisa el derecho que deseas ejercer:</p>
                                                <TextareaAutosize {
                                                    ...register("info",
                                                        {
                                                            required: "Detalle requerido",
                                                            maxLength: 100
                                                        }
                                                    )
                                                }
                                                    name="info"
                                                    id="info"
                                                    aria-label="empty textarea"
                                                    placeholder="" />
                                                {errors.info ?
                                                    <span className="message-error-repuestos">
                                                        {errors.info.message}
                                                    </span>
                                                    :
                                                    <span className="no-error">""</span>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <p className="mt-2 pl-md-4 titulo-legal">
                                            Términos y condiciones
                                        </p>
                                        <p className=" pr-md-3 pl-md-4 texto-legal">
                                            Declaro que la información sobre los datos personales entregada a Hyundai Ecuador y sus compañías relacionadas, es exacta, precisa, clara y verdadera. Además, declaro que he recibido suficiente información de manera clara, respecto a las consecuencias jurídicas en caso de que los datos personales consignados a la compañía, de cualquier índole, sean erróneos, inexactos, ambiguos, falsos o inexistentes.
                                        </p>
                                    </Row>
                                </Card.Body>
                                <Card.Footer style={{ marginTop: '0px' }} className="footer-repuestos">
                                    <button className="btn-repuestos">
                                        Enviar información
                                    </button>
                                </Card.Footer>
                            </form>
                        </Card>
                    </Row>
                </Container>
            </div>
        </div>
    );
}
export default InfoDerechoArco;